export default {
    data() {
      return {
        isShowMasking: false,
        wechatAppid: window?.ssrConfig?.routerConfig?.appid ?? "",
        successWxOpenApp: false,
        isNotTip: false,
        isCustomHeader: false,
        customHeaderSetting: {
          title: '',
          leftBtnClick: null,
          rightBtnText: '',
          rightBtnClick: null,
          theme: 'white'
        }
      };
    },
    computed: {
      isIOS() {
        return navigator.userAgent.toLocaleLowerCase().indexOf('mac os x') !== -1;

      },
      isAndroid() {
        return navigator.userAgent.toLocaleLowerCase().indexOf('android') !== -1;
      },
      isDingTalk() {
        return navigator.userAgent.toLowerCase().indexOf("dingtalk") !== -1;
      },
      isQQ() {
        return navigator.userAgent.toLowerCase().indexOf("qq/") !== -1;
      },
      isWechat() {
        return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
      },
      isWownowApp() {
        return navigator.userAgent.toLowerCase().indexOf("wownow") !== -1;
      },
    },
    methods: {
      getWxApproute(options = {}) {
        if(options?.type == 'good' && options?.item) {
          let {item} = options
          const baseRoute = `SuperApp://YumNow/storeProductDetail?storeNo=${item.storeNo}&goodsId=${item.productId}`;
          const route = this.getJumpUrl(baseRoute,'wxappRoute')
          return route
        }
        if(options?.type == 'store' && options?.item) {
          let {item} = options
          const baseRoute = `SuperApp://YumNow/storeDetail?storeNo=${item.storeNo}`;
          const route = this.getJumpUrl(baseRoute,'wxappRoute')
          return route
        }
        if(options?.type == 'link' && options?.item) {
          let { item } = options
          let route = this.getJumpUrl(item?.link || '','wxappRoute')
          return route
        }
        // 没有确切的链接就跳转app里当前页面链接
        return window.location.href
      },
      launchSuccess() {
        // alert('launchSuccess')
        this.successWxOpenApp = true
      },
      launchError(route) {
        // alert('launchError')
        if(this.isIOS) {
          // ios直接跳下载页
          let route = this.getJumpUrl()
          window.location.href = route
          return
        }
        // 安卓的引导浏览器打开
        this.isShowMasking = true
      },
      getJumpUrl(__url,type) {
        let jumpRoute = ''
        let url = __url;
        if (url && !!(url.indexOf('storeNo=') !== -1 || url.indexOf('storeNo%3D') !== -1)) {
          const { documentTitle } = this?.$root?.user?.dataSourceCms?.data ?? {};
          let addUrlString = `source=${encodeURIComponent(documentTitle)}&associatedId=${encodeURIComponent(this.$root.pageLabel)}`;
          url = url.indexOf('storeNo=') !== -1 ? url.replace(/storeNo=/g, `${addUrlString}&storeNo=`) : url.replace(/storeNo%3D/g, encodeURIComponent(`${addUrlString}&storeNo=`))
        }

        const shortID = window.ssrConfig?.routerConfig?.short?.shortID ?? '';
        if (url && url.indexOf('shortID%3D') < 0 && url.indexOf('shortID=') < 0 && shortID) {
          // 有问号
          let shortLink = url.indexOf('?') >= 0 ? `&shortID=${shortID}` : `?shortID=${shortID}`
          url = url + shortLink;
        }
        /**
         * 空
         * https://h5-uat.lifekh.com/mobile-h5/dynamic-web/65483de5a64558002fdb062a?pageLable=1722193265943863296
         * /mobile-h5/dynamic-web/65483de5a64558002fdb062a?pageLable=1722193265943863296
         * /app-wownow-links/wownow/down-loading
         * https://h5-uat.lifekh.com
         * 外链
         * scheme
         * superapp://h5.lifekh.com/wakeup?routepath=encode(路由)
         * superapp://wownow/route?url=encode(路由)
         * 微信统一跳下载页
         * this.$root.isWechat
         */
        const isWownowPath = url && url.toLocaleLowerCase().indexOf('superapp://') === 0;
        if (this.$root.isWownowApp) {
          if (isWownowPath) {
            jumpRoute = {navigationToRoute: url}
            return jumpRoute
          }
          if (url) {
            jumpRoute = process.env.NODE_ENV === 'development' && url.indexOf('://') === -1 ? `https://h5-sit.lifekh.com/${url}`.replace(/.com\/\//g, '.com/') : url;
            return jumpRoute;
          }
        } else {
          if (url && !isWownowPath) {
            jumpRoute = process.env.NODE_ENV === 'development' && url.indexOf('://') === -1 ? `https://h5-sit.lifekh.com/${url}`.replace(/.com\/\//g, '.com/') : url;
            return jumpRoute;
          }
          // 非WOWNOW内, 跳转下载页?
          let href = url || window.location.href;
          let schemePath = (isWownowPath ? url : '') || href

          // 微信里跳app的话
          if(type == 'wxappRoute') {
            jumpRoute = schemePath
            return jumpRoute
          }
          jumpRoute = `https://m.ozos.xyz/app-wownow-links/wownow/down-loading?routePath=${encodeURIComponent(schemePath)}`
          return jumpRoute;
        }
    }
    }
  };
